import Api from "./baseApi";

export default {
  status: () => Api.get("/api/invoice-labor/status"),
  setStatus: (tenantId, active) => Api.put(`/api/invoice-labor/status/${tenantId}`, { active }),
  products: tenantId => Api.get("/api/invoice-labor/products", { params: { tenantId } }),
  setProducts: (tenantId, productIds, invoiceLaborCost) =>
    Api.put("/api/invoice-labor/products", { tenantId, productIds, invoiceLaborCost }),
  held: () => Api.get("/api/invoice-labor/held")
};
